var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowDownLong = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "15px",
    viewBox: "0 0 12 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 2 Copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document-creation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(5.800000, 7.800000) rotate(-270.000000) translate(-5.800000, -7.800000) translate(-0.200000, 2.800000)",
    fill: "#66738D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Line-7",
    points: "11.3 4.3 11.3 5.3 -0.5 5.3 -0.5 4.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    points: "6.24644661 0.353553391 6.95355339 -0.353553391 12.1071068 4.8 6.95355339 9.95355339 6.24644661 9.24644661 10.693 4.8"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDownLong, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-down-long.3774e09a.svg";
export { ForwardRef as ReactComponent };